/* import __COLOCATED_TEMPLATE__ from './cordova.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();